import { createContext, useContext } from 'react';

export const UserContext = createContext(null);
export const useUser = () => useContext(UserContext);

export function decodeToken(token) {
  if (!token) return null;
  try {
    const payload = token.split('.')[1];
    return JSON.parse(atob(payload));
  } catch {
    return null;
  }
}

export const ROLE_LABELS = {
  tech:              'Field Tech',
  field_engineer:    'Field Engineer',
  rpm:               'RPM',
  design:            'Design',
  management:        'Management',
  admin:             'Admin',
  field_manager:     'Field Manager',
  director:          'Director',
  managing_director: 'Managing Director',
};

export const ROLE_COLORS = {
  tech:              '#3b82f6',
  field_engineer:    '#8b5cf6',
  rpm:               '#f59e0b',
  design:            '#10b981',
  management:        '#ef4444',
  admin:             '#6366f1',
  field_manager:     '#06b6d4',
  director:          '#f97316',
  managing_director: '#ec4899',
};

export const STATUS_LABELS = {
  submitted:         'Submitted',
  fe_review:         'FE Review',
  fe_site_visit:     'Site Visit',
  change_submitted:  'Change Submitted',
  change_approved:   'Change Approved',
  mop_draft:         'MOP Draft',
  mop_approved:      'MOP Approved',
  ready_to_work:     'Ready to Schedule',
  in_progress:       'In Progress',
  field_install_complete: 'Field Install Complete',
  fmp_pending:       'FMP Pending',
  design_review:     'Design Review',
  closed:            'Closed',
  // Incident / WO Task (ops) flow
  new:               'New',
  dispatched:        'Dispatched',
  accepted:          'Accepted',
  resolved:          'Resolved',
  cancelled:         'Cancelled',
};

export const STATUS_COLORS = {
  submitted:         '#64748b',
  fe_review:         '#8b5cf6',
  fe_site_visit:     '#a855f7',
  change_submitted:  '#fb923c',
  change_approved:   '#eab308',
  mop_draft:         '#f59e0b',
  mop_approved:      '#22c55e',
  ready_to_work:     '#10b981',
  in_progress:       '#3b82f6',
  field_install_complete: '#0d9488',
  fmp_pending:       '#f97316',
  design_review:     '#ec4899',
  closed:            '#6366f1',
  // Incident / WO Task (ops) flow
  new:               '#64748b',
  dispatched:        '#8b5cf6',
  accepted:          '#22c55e',
  resolved:          '#0d9488',
  cancelled:         '#ef4444',
};

export const PRIORITY_COLORS = {
  low:      '#64748b',
  normal:   '#3b82f6',
  high:     '#f59e0b',
  critical: '#ef4444',
};

// Per-category status flows. Project = full engineering flow; Incident (incl. WO Tasks) = ops flow.
// Anything not listed (e.g. Inspection, for now) falls back to the Project flow.
export const WORKFLOWS = {
  Project: [
    'submitted','fe_review','fe_site_visit','change_submitted','change_approved',
    'mop_draft','mop_approved','ready_to_work','in_progress','field_install_complete',
    'fmp_pending','design_review','closed',
  ],
  Incident: ['new','dispatched','accepted','in_progress','resolved','closed'],
};

// Ordered status list for a work item's category (defaults to the Project flow).
export function workflowFor(category) {
  return WORKFLOWS[category] || WORKFLOWS.Project;
}

// Off-ramp statuses that sit outside the linear flow.
export const OFFRAMP_STATUSES = ['cancelled'];
